import React from 'react';
import NavigationItem from '../ComponentsBrafab/NavigationItem';
import { useSelector } from 'react-redux';

const Navigation = () => {
    const { contentLinks, additionalLinks } = useSelector((state) => state.navigation);
    return <NavigationItem links={contentLinks} additionalLinks={additionalLinks} />;
};

export default Navigation;
